import React, { useContext, useEffect, useState } from 'react';
import styles from "../SideBarStyles.module.css";
import { Box, List } from "@mui/material";
import CustomListItem from "./CustomListItem";
import { getSidebarOptionList } from "../getSidebarOptionList";
import { UserContext, UserPayload } from "../../../Context/userContext";
import { useLocation, useNavigate } from "react-router-dom";

export interface ISideBarOptionList {
    itemName: string,
    componentName: string,
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>,
    flagAllow: boolean,
    subMenu: ISideBarOptionList[],
    externalLink?: string
}

type RoutesConfig = {
    [key: string]: string[];
};

const routes: RoutesConfig = {
    quotes: [],
    agencies: [],
    priceVersioning: [],
    insights: [],
    escalated: [],
    settings: ["3PS", "LNID"],
    threepscodes: [],
    agents: []
};

const CustomListItems: React.FC = (props) => {

    const {
        userDetail,
        activeComponent,
        setActiveComponent
    } = useContext(UserContext) as UserPayload;

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const firstSegment = location.pathname.split('/')[1]?.toLowerCase() || "insights";
        const secondSegment = location.pathname.split('/')[2] ?? null;

        const activeRoute = Object.keys(routes).find(
            route => route.toLowerCase() === firstSegment
        ) || "insights";

        const validSubsections = routes[activeRoute] || [];
        const activeSubRoute = secondSegment && validSubsections.includes(secondSegment)
            ? secondSegment
            : null;

        setActiveComponent({ activeSection: activeRoute, activeSubSection: activeSubRoute });
    }, [location.pathname]);

    const IsOptionValid = (menuItem: ISideBarOptionList): boolean => {
        if (menuItem.subMenu?.length) {
            return menuItem.subMenu.some(element =>
                userDetail.value.userRoles.some(role => role.roleName === element.itemName)
            );
        }
        return menuItem.flagAllow || userDetail.value.userRoles.some(role => role.roleName === menuItem.itemName);
    };

    const handleSectionChange = (sectionName: string, subSectionName: string = "") => {
        const section = getSidebarOptionList.find(
            (item) => item.componentName === sectionName
        );
        if (section?.externalLink) {
            window.open(section.externalLink, "_blank", "noopener,noreferrer");
            return;
        }

        const navigationPath = subSectionName ? `/${sectionName}/${subSectionName}` : `/${sectionName}`;
        navigate(navigationPath);
    }

    return (
        <React.Fragment>
            <Box className={styles.listCtn}>
                <List className={styles.listOutCtn}>
                    {getSidebarOptionList.map((section, index) => {
                        const flagValid = IsOptionValid(section);

                        if (!flagValid) {
                            return null;
                        }

                        return (
                            <CustomListItem
                                key={index}
                                sectionName={section.itemName}
                                sectionId={section.componentName}
                                isActive={section.componentName === activeComponent.activeSection}
                                activeSubSection={activeComponent.activeSubSection}
                                SectionIcon={section.icon}
                                subSections={section.subMenu}
                                handleSectionChange={handleSectionChange}
                            />
                        );
                    })}
                </List>
            </Box>
        </React.Fragment>
    );
};

export default CustomListItems;
